import React from "react";
import NewAuth from "./NewAuth";
export const Dashboard = ({ code }) => {
  const accessToken = NewAuth(code);
  return <div>{code}</div>;
};
